import React from 'react'

import SessionTemplate from 'templates/SessionTemplate'
import TitleLabel from 'components/TitleLabel'
import { Form } from './components'

const Login = () => {
  return (
    <SessionTemplate>
      <TitleLabel title="Login" label="Faça seu" />
      <Form />
    </SessionTemplate>
  )
}

export default Login
